/**
 * Application Configuration
 * 
 * These values can be overridden by environment variables.
 * Create a .env.local file in the frontend root to customize.
 * 
 * Example .env.local:
 * REACT_APP_COMPANY_NAME=My Company
 * REACT_APP_DEFAULT_THEME=dark
 */

const appConfig = {
  // Company Information
  companyName: process.env.REACT_APP_COMPANY_NAME || 'GPS Rental',
  companyShortName: process.env.REACT_APP_COMPANY_SHORT_NAME || 'GPS',
  
  // Theme defaults
  defaultDarkMode: process.env.REACT_APP_DEFAULT_DARK_MODE === 'true',
  
  // Colors (can be customized via env)
  primaryColor: process.env.REACT_APP_PRIMARY_COLOR || '#1976d2',
  secondaryColor: process.env.REACT_APP_SECONDARY_COLOR || '#dc004e',
  
  // API Configuration
  apiBaseUrl: process.env.REACT_APP_API_URL || '',
  
  // Feature flags
  enableClientPortal: process.env.REACT_APP_ENABLE_CLIENT_PORTAL !== 'false',
  enablePayments: process.env.REACT_APP_ENABLE_PAYMENTS !== 'false',
};

export default appConfig;
